<template>
  <section
    class="content"
    v-if="page.main_text || page.main_text_2nd_column || page.images || isNewsPage"
  >
    <div class="inner">
      <div class="columns" v-if="!isNewsPage">
        <div class="col" v-html="page.main_text"></div>

        <div :class="{images: page.images && page.images.length}" class="col">
          <div v-html="page.main_text_2nd_column"></div>
          <img :key="image._id" :alt="image.alt" :src="image.image" v-for="image in page.images" />
        </div>
      </div>

      <template v-if="isNewsPage">
        <div class="columns" v-html="page.main_text"></div>

        <div :key="article._id" class="columns article" v-for="article in page.articles">
          <div class="col">
            <h3>{{article.name}}</h3>
            <span v-html="article.content"></span>
          </div>
          <div class="col images">
            <img :alt="article.name" :src="article.image" />
          </div>
        </div>
      </template>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters } from "vuex"

export default {
  name: "PageContent",
  computed: {
    ...mapState(["page"]),
    ...mapGetters(["isHomePage", "isNewsPage"])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
  padding: 6rem 3%;
}

.central {
  text-align: center;
}

.col {
  width: 47.5%;
  float: left;
  margin-right: 5%;
}

.col:last-child {
  margin-right: 0;
}

.article {
  display: table;
  width: 100%;
  border-top: 3px solid #f5f5f5;
  margin-top: 5rem;
  padding-top: 5rem;
}

.article:nth-child(2) {
  margin-top: 2rem;
}

.article .col:first-child {
  width: 70%;
}

.article .col:last-child {
  width: 25%;
}

.article:nth-child(odd) .col:first-child {
  float: right;
  margin-left: 5%;
  margin-right: 0;
}

.padded {
  padding-top: 7rem;
}

.images img {
  width: 100%;
}

strong {
  color: #bb9765;
}

.content >>> img {
  height: auto !important;
}

.content >>> ul,
.content >>> ol {
  padding-left: 2rem;
}

.content >>> a {
  text-decoration: underline;
}

@media screen and (max-width: 850px) {
  .content {
    padding: 3rem 3%;
  }
  .col {
    width: 100% !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}
</style>
